<template>
    <div class="container">
        <div class="row card">
            <div class="col-sm-10">
                <h2>Thanks for purchasing!</h2>
                <!-- <hr /> -->
                <!-- <br /> -->
                <router-link to="/">
                    <b-button variant="primary" class="mt-3">
                        Back Home
                    </b-button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Success',
}
</script>

<style scoped></style>
